/**
 * @desc 删除接口作用域及其关联关系
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(code: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/apiScope/${code}`, {
      method: "DELETE",

      ...options,
    }),
  );
}
